module.exports = __webpack_public_path__ + "static/media/icon-chevon-right-white.4859ed4d.svg";